import { useContext } from 'react';

import { ModuleConfigContext } from './ModuleConfigProvider.context';

export const useModuleConfig = <C>(): C => {
  const context = useContext(ModuleConfigContext) as unknown as C;
  if (!context) {
    throw new Error('useModuleConfig must be used within a ModuleConfigProvider');
  }
  return context;
};
